import React, { useEffect, useState } from "react";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import VirtualTable from "../ui/VirtualTable";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { bm_date } from "../utils/Utils";
import Divider from "../ui/Divider";
import Space from "../ui/Space";
import Input from "../ui/Input";
import Label, { DisplayLabel } from "../ui/Label";
import TextArea from "../ui/TextArea";
import { ROUTES } from "../utils/Routes";
import Nav from "../ui/Nav";
import Spin from "../ui/Spin";
import dayjs from "dayjs";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import Float from "../ui/Float";

export default function OrderTrack(props) {

    const {
        controller = "",
        callback = () => { },
        route = ROUTES.HISTORY.ORDER_TRACK,
    } = props;

    const [data, setData] = useState(props.data);
    const [selected, setSelected] = useState((data?.length > 0) ? data[0] : {})
    const [loading, setLoading] = useState(false);
    const row_key = "invoice_id";

    const [status, setStatus] = useState("Tracking information displayed.")
    const updateRow = (_row) => {
        let _data = [...data];
        let _f = _data.findIndex(item => item?.[row_key] === _row?.[row_key]);
        if (_f > -1) {

            if (_data[_f]?.last_update_date !== _row?.last_update_date) {
                setStatus("Tracking information updated.")
            } else {
                setStatus("No new information.")
            }

            _data[_f] = _row;
            setSelected(_row);
            setData(_data);
        }
    }


    const updateTracking = (_selected = selected) => {
        setLoading(true);
        pubCall("shipment_tracking.update", { invoice_id: selected?.[row_key] }, (_s, _r) => {
            if (_s) {

                updateRow(_r);

            } else {
                showError(_r);
            }
            setLoading(false);
        })
    }

    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.U, text: "Update", action: () => { updateTracking(selected) } },
    ]

    useEffect(() => {

        if (loading) {
            return;
        }
        const cleanup = listen(controller, route, actions, false, [KBD.ENTER]);
        return cleanup;
    }, [actions, selected, loading])


    useEffect(() => {
        window.bm_state.value = route;
    }, [])



    const event_columns = [
        {
            key: "date_time", title: <>Event date/time</>, align: "left", width: 150, render: (e) => {
                return dayjs(e).format("MMMDD-YY H:mm")
            }
        },
        { key: "city", title: <>City</>, align: "left", width: 100 },
        { key: "province", title: <>Pr</>, align: "left", width: 35 },
        { key: "event", grow: true, title: <>Event</>, align: "left", width: 35 },
    ]

    const columns = [
        { key: "quantity", title: <>Qty</>, align: "right", width: 35 },
        { key: "supplier", title: <>Sup</>, align: "left", width: 85 },
        {
            key: "tracking_number", title: <>Tracking #</>, align: "left", grow: true, width: 200
        },
        {
            key: "ship_date", title: <>Ship Date</>, align: "left", width: 100, render: (e) => {
                return <span style={{"fontFamily" : "var(--font-mono)"}}>{bm_date(e)}</span>
            }
        },
        {
            key: "delivery_date", title: <>Expected Date</>, align: "left", width: 100, render: (e) => {
                return <span style={{"fontFamily" : "var(--font-mono)"}}>{bm_date(e)}</span>
            }
        },

    ];




    const next = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }

        const nextIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) + _rows;
        if (data.length <= nextIndex) {
            setSelected(data[data.length - 1]);
        }

        if (nextIndex < data.length) {
            setSelected(data[nextIndex]);
        }
    };
    const prev = (_rows = 1) => {
        if (data.length === 0) { setSelected({}); return; }
        const prevIndex = data.findIndex(item => item?.[row_key] === selected?.[row_key]) - _rows;
        if (prevIndex < 0) {
            setSelected(data[0]);
            return;
        }
        if (prevIndex >= 0) {
            setSelected(data[prevIndex]);
        }
    };

    const isTodayOrYesterday = (timestamp) => {
        const date = dayjs(timestamp);
        const today = dayjs();

        if (date.isSame(today, 'day')) {
            return 'Today';
        }

        if (date.isSame(today.subtract(1, 'day'), 'day')) {
            return 'Yesterday';
        }

        return bm_date(timestamp)
    }

    const daysFromNow = (timestamp) => {
        const days = dayjs(timestamp).diff(dayjs(), "day");

        if (days && days >= 0) {
            return days + " Days ";
        } else {
            if (days && days < 0) {
                return (days * -1) + " Days ago ";
            }
            return "";
        }

    };


    return (
        <Spin loading={loading}>
            <div style={{ "width": "772px" }}>

                <div className="shim" /> <div className="shim" />

                <Space size="10">
                    <Label width={70}>Supplier</Label>
                    <DisplayLabel className="value" width={270} value={selected?.supplier} />
                    <div>&nbsp;&nbsp;</div>
                    <Label width={80}>Invoice Date</Label>
                    <DisplayLabel className="value" width={300} value={bm_date(selected?.invoice_date)} />
                </Space>

                <Space size="10">
                    <Label width={70}>Carton#</Label>
                    <DisplayLabel className="value" width={270} value={selected?.carton_number} />
                    <div>&nbsp;&nbsp;</div>
                    <Label width={80}>Invoice#</Label>
                    <DisplayLabel className="value" width={300} value={selected?.invoice_number} />
                </Space>

                <Space size="10">
                    <Label width={70}>Carrier</Label>
                    <DisplayLabel className="value text-yellow" width={270} value={selected?.carrier} />
                    <div>&nbsp;&nbsp;</div>
                    <Label width={80}>PackSlip#</Label>
                    <DisplayLabel className="value" width={300} value={selected?.pack_slip_number} />
                </Space>

                <Space size="10">
                    <Label width={70}>Tracking#</Label>
                    <DisplayLabel className="value text-yellow" width={270} value={selected?.tracking_number} />
                    <div>&nbsp;&nbsp;</div>
                    <Label width={80}>BOL</Label>
                    <DisplayLabel className="value" width={300} value={selected?.bill_of_landing} />
                </Space>


                <Space size="10">
                    <Label width={70}>Expected</Label>
                    <DisplayLabel className="value text-green" width={270} value={daysFromNow(selected?.delivery_date) + "(" + bm_date(selected?.delivery_date) + ")"} />
                    <div>&nbsp;&nbsp;</div>
                    <Label width={80}>Shipped</Label>
                    <DisplayLabel className="value" width={300} value={daysFromNow(selected?.ship_date) + "(" + bm_date(selected?.ship_date) + ")"} />
                </Space>


                <Space size="10">
                    <Label width={70}>Updated</Label>
                    <DisplayLabel className="value" width={270} value={isTodayOrYesterday(selected?.last_update_date)} />
                    <div>&nbsp;&nbsp;</div>

                </Space>


                <div className="shim" />
                <Space size="10" style={{ "alignItems": "start" }}>
                    <Label width={70}>Status</Label>
                    <DisplayLabel className="value" style={{ "height": "50px", "whiteSpace": "wrap" }} width={687} rows={2} value={selected?.status} />
                    <div>&nbsp;&nbsp;</div>
                </Space>

                {(selected?.events?.length > 0 && <>

                    <VirtualTable
                        controller={controller}
                        next={next}
                        scrollbar={true}
                        prev={prev}
                        align={"auto"}
                        row_key={row_key}
                        current={selected}
                        data={selected.events}
                        columns={event_columns}
                        width={772}
                        height={200}
                        loading={false}
                        offset={0}
                        route={route}
                    />
                    <div className="shim" />
                </>)}

                {(data?.length > 1 &&

                    <VirtualTable
                        controller={controller}
                        onRowClick={(item, event, index) => { setSelected(item) }}
                        next={next}
                        scrollbar={true}
                        prev={prev}
                        align={"auto"}
                        row_key={row_key}
                        current={selected}
                        data={data}
                        columns={columns}
                        width={772}
                        height={200}
                        loading={false}
                        offset={0}
                        route={route}
                    />
                )}

                {(data?.length <= 1 &&
                    <Divider style={{ margin: "5px -10px" }} />
                )}

                <div className="shim" />
                <Float>
                    <div style={{ "width": "100px" }}><Nav nav={actions} /></div>
                    <div style={{ "width": "100%", "marginTop": "1px" }}>
                        <Status type="active"><InfoIcon />{status}</Status>
                    </div>
                </Float>

            </div>
        </Spin>
    )
}